import React, {FC, useEffect} from 'react';

import {useInView} from 'react-intersection-observer';

import {AccessoryType} from '../../store/reducers/accessories/accessoriesType';

import s from './accessoryItemWrapper.scss';

export type PropsType = {
    accessory: AccessoryType;
    children: React.ReactNode;
    onView: (upsell: AccessoryType, isLastElement: boolean) => void;
    isLastElement: boolean;
};

/**
 * Accessory item wrapper for initializing the visibility of an accessory block
 * @param {PropsType} props - Component props
 * @returns {React.ReactElement} - Rendered accessory item wrapper
 */
export const AccessoryItemWrapper: FC<PropsType> = ({
    accessory,
    children,
    isLastElement,
    onView,
}) => {
    const {inView, ref} = useInView({
        threshold: 0.9,
        triggerOnce: true,
    });

    useEffect(() => {
        if (inView) onView(accessory, isLastElement);
    }, [inView]);

    return (
        <div className={s.accessoryWrapper} ref={ref}>
            {children}
        </div>
    );
};
